module.exports = __webpack_public_path__ + "static/media/Nuggets-logo.74b8f5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nuggets-logo.png
// module id = 277
// module chunks = 0